var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Select from 'react-select';
var defaultTheme = function (theme) { return (__assign(__assign({}, theme), { borderRadius: 0, colors: __assign(__assign({}, theme.colors), { primary25: '#c4c4c4', primary: '#2d2d2d' }) })); };
function isOptionDisabled(option) {
    return !!option.disabled;
}
export default function ThemedSelect(_a) {
    var options = _a.options, value = _a.value, _b = _a.theme, theme = _b === void 0 ? null : _b, props = __rest(_a, ["options", "value", "theme"]);
    if (typeof value !== 'undefined') {
        options.some(function (opt) {
            if ('value' in opt && opt.value === value) {
                value = opt;
                return true;
            }
            if (opt.options)
                opt.options.some(function (subopt) {
                    if (subopt.value === value) {
                        value = subopt;
                        return true;
                    }
                    return false;
                });
            return false;
        });
    }
    var themeOverride = function (styles) {
        styles = defaultTheme(styles);
        if (theme)
            styles = theme(styles);
        return styles;
    };
    return (React.createElement(Select, __assign({ theme: themeOverride, isOptionDisabled: isOptionDisabled, menuPlacement: "auto", menuPosition: "fixed", options: options, value: value }, props)));
}
